var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1863_10585",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1863_10585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.59998 11.3333L7.99998 8.93325L10.4 11.3333L11.3333 10.3999L8.93331 7.99992L11.3333 5.59992L10.4 4.66658L7.99998 7.06659L5.59998 4.66658L4.66665 5.59992L7.06665 7.99992L4.66665 10.3999L5.59998 11.3333ZM7.99998 14.6666C7.07776 14.6666 6.21109 14.4915 5.39998 14.1413C4.58887 13.7915 3.88331 13.3166 3.28331 12.7166C2.68331 12.1166 2.20842 11.411 1.85865 10.5999C1.50842 9.78881 1.33331 8.92214 1.33331 7.99992C1.33331 7.0777 1.50842 6.21103 1.85865 5.39992C2.20842 4.58881 2.68331 3.88325 3.28331 3.28325C3.88331 2.68325 4.58887 2.20814 5.39998 1.85792C6.21109 1.50814 7.07776 1.33325 7.99998 1.33325C8.9222 1.33325 9.78887 1.50814 10.6 1.85792C11.4111 2.20814 12.1166 2.68325 12.7166 3.28325C13.3166 3.88325 13.7915 4.58881 14.1413 5.39992C14.4915 6.21103 14.6666 7.0777 14.6666 7.99992C14.6666 8.92214 14.4915 9.78881 14.1413 10.5999C13.7915 11.411 13.3166 12.1166 12.7166 12.7166C12.1166 13.3166 11.4111 13.7915 10.6 14.1413C9.78887 14.4915 8.9222 14.6666 7.99998 14.6666ZM7.99998 13.3333C9.48887 13.3333 10.75 12.8166 11.7833 11.7833C12.8166 10.7499 13.3333 9.48881 13.3333 7.99992C13.3333 6.51103 12.8166 5.24992 11.7833 4.21658C10.75 3.18325 9.48887 2.66659 7.99998 2.66659C6.51109 2.66659 5.24998 3.18325 4.21665 4.21658C3.18331 5.24992 2.66665 6.51103 2.66665 7.99992C2.66665 9.48881 3.18331 10.7499 4.21665 11.7833C5.24998 12.8166 6.51109 13.3333 7.99998 13.3333Z",
    fill: "#F0505A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.12b377d3e695079017c6b7de00374d9d.svg";
export { ForwardRef as ReactComponent };